export default __webpack_public_path__ + "static/media/goldcresttowera.32ebd0ae.jpeg";